import { Link } from 'react-router-dom'
import { toast, Flip } from 'react-toastify'
import { AppContext } from '../../AppContext'
import { userStatus } from '../../layout/Names'
import { useContext, useState, useEffect } from 'react'

const ListUsers = () => {
    const [ users, setUsers ] = useState([])
    const { setLoading, hostBase } = useContext(AppContext)
    const [ filteredUsers, setFilteredUsers ] = useState([])
    const [ filter, setFilter ] = useState({s: '', status: ''})

    const updateField = (e) => {
        let _filter = {...filter}
        _filter[e.target.name] = e.target.value
        setFilter(_filter)
    }
    
    useEffect(() => {
        if(users.length === 0){
            setLoading(true)
            const token = localStorage.getItem('userToken')
            fetch(`${hostBase}/api/user/list/?token=${token}`)
                .then(res => res.json())
                .then((data) => {
                    if(data.length !== 0)
                        setUsers(data)
                    else
                        toast.error('No se encontró ningún usuario.', { theme: "colored", transition: Flip })
                })
                .catch((e) => { toast.error('Ocurrió un error al intentar traer el listado de usuarios administradores.', { theme: "colored", transition: Flip }) })
                .finally(() => setLoading(false))
        }else if(users.length > 0)
            setFilteredUsers(users.filter(u => ((u.name.toLowerCase().search(filter.s.toLowerCase()) !== -1 || u.email.toLowerCase().search(filter.s.toLowerCase()) !== -1) && (filter.status == '' || u.status == filter.status))))
    }, [users, filter])

    return (
        <div className="userList">
            <div className="filters">
                <input type="text" name="s" value={filter?.s || ''} placeholder="Buscar..." onChange={updateField} autoComplete="off" />
                <select name="status" value={filter?.status || ''} onChange={updateField}>
                    <option value="">Todos los estados</option>
                    <option value="Activo">Activo</option>
                    <option value="Inactivo">Inactivo</option>
                </select>
            </div>
            <h2>Administradores</h2>
            { filteredUsers?.length !== 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Correo electrónico</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        { filteredUsers.map((u) => {
                            return (
                                <tr key={u.uid}>
                                    <td>{u.name}</td>
                                    <td>{u.email}</td>
                                    <td>{userStatus[u.status]}</td>
                                    <td className="btn"><Link className="button min" to={`/administradores/editar/${u.uid}`}>Ver información</Link></td>
                                </tr>
                            )
                        }) }
                    </tbody>
                </table>
            ) : <p>No se encontró ningún administrador.</p> }
            <Link to="/administradores/crear/" className="button">Crear nuevo usuario administrador</Link>
        </div>
    )
}
export default ListUsers